module.exports = __webpack_public_path__ + "img/qr-code-interactive.e25d3092.svg";